import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTopOnNavigate = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        // Scroll to top when the pathname changes
        window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant' // Use 'instant' for immediate scroll without animation
        });
    }, [pathname]);

    return null; // This component doesn't render anything
};

export default ScrollToTopOnNavigate;